export default "__VITE_ASSET__dfffa1ba__"